import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SidebarSearch from 'components/search_sidebar/sidebar_search';
import SavedSearchTopbar from '../saved_search/saved_search_topbar';

import { changeSearchText } from '../store/actions/query';
import { delayRetrieveRecords } from '../store/actions/search';
import { getSearchText } from '../store/selectors/query';

export class FilterRow extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    delayRetrieveRecords: PropTypes.func,
    searchPlaceholder: PropTypes.string,
    searchText: PropTypes.string,
    onSearchChange: PropTypes.func.isRequired
  }

  static defaultProps = {
    searchPlaceholder: 'Search by contact, company or name'
  }

  handleSearchChange = (e) => {
    const { onSearchChange, delayRetrieveRecords } = this.props;
    onSearchChange(e.target.value);
    delayRetrieveRecords();
  };

  render() {
    return (
      <div className="pl-3 container-fluid">
        <div className="filters-row">
          {this.renderSearchBar()}
          <div className="hidden-xs hidden-sm d-inline-flex">
            {this.props.children}
          </div>
        </div>
        <div className="d-inline-block page-count pull-right">
          <SavedSearchTopbar />
        </div>
      </div>
    );
  }

  renderSearchBar() {
    const { searchPlaceholder, searchText } = this.props;

    return (
      <SidebarSearch
        name="search_text"
        placeholder={searchPlaceholder}
        value={searchText}
        onChange={this.handleSearchChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  searchText: getSearchText(state),
});

const mapDispatchToProps = {
  delayRetrieveRecords,
  onSearchChange: changeSearchText
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterRow);
